import './Seperator.33c16065c96b3bfa078215f4cc2d0c15.css';
export default {"separator":"_separator_118vk_1","vertical":"_vertical_118vk_1"};